import {State} from '../../types'

export const getRowValue = (
  state: State,
  row: Record<string, string>,
  key: string
): string => {
  return row[state.columnTitlesMap[key]]?.trim() || ''
}
